// OnboardingGuard.js
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import PageLoading from "src/component/PageLoading";
import { getCurrentAuthState } from "src/utils/authUtils";

const OnboardingGuard = ({ children }) => {
  const [redirectPath, setRedirectPath] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuthStatus = async () => {
      const authState = await getCurrentAuthState(false);

      console.log("🔐 [OnboardingGuard]", authState);

      if (!authState.isAuthenticated) {
        setRedirectPath("/secure/login");
      } else if (authState.hasProfile) {
        setRedirectPath("/secure/portfolio");
      } else {
        // Show onboarding
        setRedirectPath(null);
      }

      setLoading(false);
    };

    checkAuthStatus();
  }, []);

  if (loading) return <PageLoading />;
  if (redirectPath) return <Redirect to={redirectPath} />;
  return children;
};

export default OnboardingGuard;